/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  fixDecoderSize,
  fixEncoderSize,
  getAddressEncoder,
  getBytesDecoder,
  getBytesEncoder,
  getOptionDecoder,
  getOptionEncoder,
  getProgramDerivedAddress,
  getStructDecoder,
  getStructEncoder,
  getU128Decoder,
  getU128Encoder,
  getU64Decoder,
  getU64Encoder,
  SOLANA_ERROR__PROGRAM_CLIENTS__INSUFFICIENT_ACCOUNT_METAS,
  SolanaError,
  transformEncoder,
  type AccountMeta,
  type AccountSignerMeta,
  type Address,
  type Codec,
  type Decoder,
  type Encoder,
  type Instruction,
  type InstructionWithAccounts,
  type InstructionWithData,
  type Option,
  type OptionOrNullable,
  type ReadonlyAccount,
  type ReadonlyUint8Array,
  type TransactionSigner,
  type WritableAccount,
  type WritableSignerAccount,
} from '@solana/kit';
import {
  getAccountMetaFactory,
  getAddressFromResolvedInstructionAccount,
  type ResolvedInstructionAccount,
} from '@solana/program-client-core';
import { DOPPLER_REHYPE_ROUTER_V1_PROGRAM_ADDRESS } from '../programs';
import {
  getLpRebalanceArgsDecoder,
  getLpRebalanceArgsEncoder,
  type LpRebalanceArgs,
  type LpRebalanceArgsArgs,
} from '../types';

export const SETTLE_MIGRATED_FEES_DISCRIMINATOR = new Uint8Array([
  73, 177, 82, 102, 67, 4, 231, 200,
]);

export function getSettleMigratedFeesDiscriminatorBytes() {
  return fixEncoderSize(getBytesEncoder(), 8).encode(
    SETTLE_MIGRATED_FEES_DISCRIMINATOR,
  );
}

export type SettleMigratedFeesInstruction<
  TProgram extends string = typeof DOPPLER_REHYPE_ROUTER_V1_PROGRAM_ADDRESS,
  TAccountSettlementAuthority extends string | AccountMeta<string> = string,
  TAccountInitializerProgram extends string | AccountMeta<string> =
    '4h3Dqyo5qmteJoMxXt3tdtfXELDB6pdRTPU9mWruiKp1',
  TAccountInitializerConfig extends string | AccountMeta<string> = string,
  TAccountLaunch extends string | AccountMeta<string> = string,
  TAccountLaunchFeeState extends string | AccountMeta<string> = string,
  TAccountLaunchAuthority extends string | AccountMeta<string> = string,
  TAccountBaseMint extends string | AccountMeta<string> = string,
  TAccountQuoteMint extends string | AccountMeta<string> = string,
  TAccountLaunchBaseVault extends string | AccountMeta<string> = string,
  TAccountLaunchQuoteVault extends string | AccountMeta<string> = string,
  TAccountRehypeState extends string | AccountMeta<string> = string,
  TAccountRehypeAuthority extends string | AccountMeta<string> = string,
  TAccountRouterBaseAta extends string | AccountMeta<string> = string,
  TAccountRouterQuoteAta extends string | AccountMeta<string> = string,
  TAccountBuybackDestination extends string | AccountMeta<string> = string,
  TAccountBuybackBaseAta extends string | AccountMeta<string> = string,
  TAccountBuybackQuoteAta extends string | AccountMeta<string> = string,
  TAccountCpmmProgram extends string | AccountMeta<string> =
    '9PSxVPoPfnbZ8Q1uQhgS6ZxvBjFboZtebNsu34umxkgQ',
  TAccountCpmmConfig extends string | AccountMeta<string> = string,
  TAccountPool extends string | AccountMeta<string> = string,
  TAccountPoolAuthority extends string | AccountMeta<string> = string,
  TAccountPoolVault0 extends string | AccountMeta<string> = string,
  TAccountPoolVault1 extends string | AccountMeta<string> = string,
  TAccountProtocolFeePosition extends string | AccountMeta<string> = string,
  TAccountRouterLpPosition extends string | AccountMeta<string> = string,
  TAccountBaseTokenProgram extends string | AccountMeta<string> = string,
  TAccountQuoteTokenProgram extends string | AccountMeta<string> = string,
  TAccountAssociatedTokenProgram extends string | AccountMeta<string> =
    'ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL',
  TAccountSystemProgram extends string | AccountMeta<string> =
    '11111111111111111111111111111111',
  TAccountOracle extends string | AccountMeta<string> = string,
  TRemainingAccounts extends readonly AccountMeta<string>[] = [],
> = Instruction<TProgram> &
  InstructionWithData<ReadonlyUint8Array> &
  InstructionWithAccounts<
    [
      TAccountSettlementAuthority extends string
        ? WritableSignerAccount<TAccountSettlementAuthority> &
            AccountSignerMeta<TAccountSettlementAuthority>
        : TAccountSettlementAuthority,
      TAccountInitializerProgram extends string
        ? ReadonlyAccount<TAccountInitializerProgram>
        : TAccountInitializerProgram,
      TAccountInitializerConfig extends string
        ? ReadonlyAccount<TAccountInitializerConfig>
        : TAccountInitializerConfig,
      TAccountLaunch extends string
        ? WritableAccount<TAccountLaunch>
        : TAccountLaunch,
      TAccountLaunchFeeState extends string
        ? WritableAccount<TAccountLaunchFeeState>
        : TAccountLaunchFeeState,
      TAccountLaunchAuthority extends string
        ? ReadonlyAccount<TAccountLaunchAuthority>
        : TAccountLaunchAuthority,
      TAccountBaseMint extends string
        ? ReadonlyAccount<TAccountBaseMint>
        : TAccountBaseMint,
      TAccountQuoteMint extends string
        ? ReadonlyAccount<TAccountQuoteMint>
        : TAccountQuoteMint,
      TAccountLaunchBaseVault extends string
        ? WritableAccount<TAccountLaunchBaseVault>
        : TAccountLaunchBaseVault,
      TAccountLaunchQuoteVault extends string
        ? WritableAccount<TAccountLaunchQuoteVault>
        : TAccountLaunchQuoteVault,
      TAccountRehypeState extends string
        ? WritableAccount<TAccountRehypeState>
        : TAccountRehypeState,
      TAccountRehypeAuthority extends string
        ? ReadonlyAccount<TAccountRehypeAuthority>
        : TAccountRehypeAuthority,
      TAccountRouterBaseAta extends string
        ? WritableAccount<TAccountRouterBaseAta>
        : TAccountRouterBaseAta,
      TAccountRouterQuoteAta extends string
        ? WritableAccount<TAccountRouterQuoteAta>
        : TAccountRouterQuoteAta,
      TAccountBuybackDestination extends string
        ? ReadonlyAccount<TAccountBuybackDestination>
        : TAccountBuybackDestination,
      TAccountBuybackBaseAta extends string
        ? WritableAccount<TAccountBuybackBaseAta>
        : TAccountBuybackBaseAta,
      TAccountBuybackQuoteAta extends string
        ? WritableAccount<TAccountBuybackQuoteAta>
        : TAccountBuybackQuoteAta,
      TAccountCpmmProgram extends string
        ? ReadonlyAccount<TAccountCpmmProgram>
        : TAccountCpmmProgram,
      TAccountCpmmConfig extends string
        ? ReadonlyAccount<TAccountCpmmConfig>
        : TAccountCpmmConfig,
      TAccountPool extends string
        ? WritableAccount<TAccountPool>
        : TAccountPool,
      TAccountPoolAuthority extends string
        ? ReadonlyAccount<TAccountPoolAuthority>
        : TAccountPoolAuthority,
      TAccountPoolVault0 extends string
        ? WritableAccount<TAccountPoolVault0>
        : TAccountPoolVault0,
      TAccountPoolVault1 extends string
        ? WritableAccount<TAccountPoolVault1>
        : TAccountPoolVault1,
      TAccountProtocolFeePosition extends string
        ? WritableAccount<TAccountProtocolFeePosition>
        : TAccountProtocolFeePosition,
      TAccountRouterLpPosition extends string
        ? WritableAccount<TAccountRouterLpPosition>
        : TAccountRouterLpPosition,
      TAccountBaseTokenProgram extends string
        ? ReadonlyAccount<TAccountBaseTokenProgram>
        : TAccountBaseTokenProgram,
      TAccountQuoteTokenProgram extends string
        ? ReadonlyAccount<TAccountQuoteTokenProgram>
        : TAccountQuoteTokenProgram,
      TAccountAssociatedTokenProgram extends string
        ? ReadonlyAccount<TAccountAssociatedTokenProgram>
        : TAccountAssociatedTokenProgram,
      TAccountSystemProgram extends string
        ? ReadonlyAccount<TAccountSystemProgram>
        : TAccountSystemProgram,
      TAccountOracle extends string
        ? WritableAccount<TAccountOracle>
        : TAccountOracle,
      ...TRemainingAccounts,
    ]
  >;

export type SettleMigratedFeesInstructionData = {
  discriminator: ReadonlyUint8Array;
  minBaseToQuoteOut: bigint;
  minQuoteToBaseOut: bigint;
  lpRebalance: Option<LpRebalanceArgs>;
  minLpSharesOut: bigint;
};

export type SettleMigratedFeesInstructionDataArgs = {
  minBaseToQuoteOut: number | bigint;
  minQuoteToBaseOut: number | bigint;
  lpRebalance: OptionOrNullable<LpRebalanceArgsArgs>;
  minLpSharesOut: number | bigint;
};

export function getSettleMigratedFeesInstructionDataEncoder(): Encoder<SettleMigratedFeesInstructionDataArgs> {
  return transformEncoder(
    getStructEncoder([
      ['discriminator', fixEncoderSize(getBytesEncoder(), 8)],
      ['minBaseToQuoteOut', getU64Encoder()],
      ['minQuoteToBaseOut', getU64Encoder()],
      ['lpRebalance', getOptionEncoder(getLpRebalanceArgsEncoder())],
      ['minLpSharesOut', getU128Encoder()],
    ]),
    (value) => ({
      ...value,
      discriminator: SETTLE_MIGRATED_FEES_DISCRIMINATOR,
    }),
  );
}

export function getSettleMigratedFeesInstructionDataDecoder(): Decoder<SettleMigratedFeesInstructionData> {
  return getStructDecoder([
    ['discriminator', fixDecoderSize(getBytesDecoder(), 8)],
    ['minBaseToQuoteOut', getU64Decoder()],
    ['minQuoteToBaseOut', getU64Decoder()],
    ['lpRebalance', getOptionDecoder(getLpRebalanceArgsDecoder())],
    ['minLpSharesOut', getU128Decoder()],
  ]);
}

export function getSettleMigratedFeesInstructionDataCodec(): Codec<
  SettleMigratedFeesInstructionDataArgs,
  SettleMigratedFeesInstructionData
> {
  return combineCodec(
    getSettleMigratedFeesInstructionDataEncoder(),
    getSettleMigratedFeesInstructionDataDecoder(),
  );
}

export type SettleMigratedFeesAsyncInput<
  TAccountSettlementAuthority extends string = string,
  TAccountInitializerProgram extends string = string,
  TAccountInitializerConfig extends string = string,
  TAccountLaunch extends string = string,
  TAccountLaunchFeeState extends string = string,
  TAccountLaunchAuthority extends string = string,
  TAccountBaseMint extends string = string,
  TAccountQuoteMint extends string = string,
  TAccountLaunchBaseVault extends string = string,
  TAccountLaunchQuoteVault extends string = string,
  TAccountRehypeState extends string = string,
  TAccountRehypeAuthority extends string = string,
  TAccountRouterBaseAta extends string = string,
  TAccountRouterQuoteAta extends string = string,
  TAccountBuybackDestination extends string = string,
  TAccountBuybackBaseAta extends string = string,
  TAccountBuybackQuoteAta extends string = string,
  TAccountCpmmProgram extends string = string,
  TAccountCpmmConfig extends string = string,
  TAccountPool extends string = string,
  TAccountPoolAuthority extends string = string,
  TAccountPoolVault0 extends string = string,
  TAccountPoolVault1 extends string = string,
  TAccountProtocolFeePosition extends string = string,
  TAccountRouterLpPosition extends string = string,
  TAccountBaseTokenProgram extends string = string,
  TAccountQuoteTokenProgram extends string = string,
  TAccountAssociatedTokenProgram extends string = string,
  TAccountSystemProgram extends string = string,
  TAccountOracle extends string = string,
> = {
  settlementAuthority: TransactionSigner<TAccountSettlementAuthority>;
  initializerProgram?: Address<TAccountInitializerProgram>;
  initializerConfig: Address<TAccountInitializerConfig>;
  launch: Address<TAccountLaunch>;
  launchFeeState: Address<TAccountLaunchFeeState>;
  launchAuthority: Address<TAccountLaunchAuthority>;
  baseMint: Address<TAccountBaseMint>;
  quoteMint: Address<TAccountQuoteMint>;
  launchBaseVault: Address<TAccountLaunchBaseVault>;
  launchQuoteVault: Address<TAccountLaunchQuoteVault>;
  rehypeState?: Address<TAccountRehypeState>;
  rehypeAuthority?: Address<TAccountRehypeAuthority>;
  routerBaseAta?: Address<TAccountRouterBaseAta>;
  routerQuoteAta?: Address<TAccountRouterQuoteAta>;
  buybackDestination: Address<TAccountBuybackDestination>;
  buybackBaseAta: Address<TAccountBuybackBaseAta>;
  buybackQuoteAta: Address<TAccountBuybackQuoteAta>;
  cpmmProgram?: Address<TAccountCpmmProgram>;
  cpmmConfig: Address<TAccountCpmmConfig>;
  pool: Address<TAccountPool>;
  poolAuthority: Address<TAccountPoolAuthority>;
  poolVault0: Address<TAccountPoolVault0>;
  poolVault1: Address<TAccountPoolVault1>;
  protocolFeePosition: Address<TAccountProtocolFeePosition>;
  routerLpPosition: Address<TAccountRouterLpPosition>;
  baseTokenProgram: Address<TAccountBaseTokenProgram>;
  quoteTokenProgram: Address<TAccountQuoteTokenProgram>;
  associatedTokenProgram?: Address<TAccountAssociatedTokenProgram>;
  systemProgram?: Address<TAccountSystemProgram>;
  oracle?: Address<TAccountOracle>;
  minBaseToQuoteOut: SettleMigratedFeesInstructionDataArgs['minBaseToQuoteOut'];
  minQuoteToBaseOut: SettleMigratedFeesInstructionDataArgs['minQuoteToBaseOut'];
  lpRebalance: SettleMigratedFeesInstructionDataArgs['lpRebalance'];
  minLpSharesOut: SettleMigratedFeesInstructionDataArgs['minLpSharesOut'];
};

export async function getSettleMigratedFeesInstructionAsync<
  TAccountSettlementAuthority extends string,
  TAccountInitializerProgram extends string,
  TAccountInitializerConfig extends string,
  TAccountLaunch extends string,
  TAccountLaunchFeeState extends string,
  TAccountLaunchAuthority extends string,
  TAccountBaseMint extends string,
  TAccountQuoteMint extends string,
  TAccountLaunchBaseVault extends string,
  TAccountLaunchQuoteVault extends string,
  TAccountRehypeState extends string,
  TAccountRehypeAuthority extends string,
  TAccountRouterBaseAta extends string,
  TAccountRouterQuoteAta extends string,
  TAccountBuybackDestination extends string,
  TAccountBuybackBaseAta extends string,
  TAccountBuybackQuoteAta extends string,
  TAccountCpmmProgram extends string,
  TAccountCpmmConfig extends string,
  TAccountPool extends string,
  TAccountPoolAuthority extends string,
  TAccountPoolVault0 extends string,
  TAccountPoolVault1 extends string,
  TAccountProtocolFeePosition extends string,
  TAccountRouterLpPosition extends string,
  TAccountBaseTokenProgram extends string,
  TAccountQuoteTokenProgram extends string,
  TAccountAssociatedTokenProgram extends string,
  TAccountSystemProgram extends string,
  TAccountOracle extends string,
  TProgramAddress extends Address =
    typeof DOPPLER_REHYPE_ROUTER_V1_PROGRAM_ADDRESS,
>(
  input: SettleMigratedFeesAsyncInput<
    TAccountSettlementAuthority,
    TAccountInitializerProgram,
    TAccountInitializerConfig,
    TAccountLaunch,
    TAccountLaunchFeeState,
    TAccountLaunchAuthority,
    TAccountBaseMint,
    TAccountQuoteMint,
    TAccountLaunchBaseVault,
    TAccountLaunchQuoteVault,
    TAccountRehypeState,
    TAccountRehypeAuthority,
    TAccountRouterBaseAta,
    TAccountRouterQuoteAta,
    TAccountBuybackDestination,
    TAccountBuybackBaseAta,
    TAccountBuybackQuoteAta,
    TAccountCpmmProgram,
    TAccountCpmmConfig,
    TAccountPool,
    TAccountPoolAuthority,
    TAccountPoolVault0,
    TAccountPoolVault1,
    TAccountProtocolFeePosition,
    TAccountRouterLpPosition,
    TAccountBaseTokenProgram,
    TAccountQuoteTokenProgram,
    TAccountAssociatedTokenProgram,
    TAccountSystemProgram,
    TAccountOracle
  >,
  config?: { programAddress?: TProgramAddress },
): Promise<
  SettleMigratedFeesInstruction<
    TProgramAddress,
    TAccountSettlementAuthority,
    TAccountInitializerProgram,
    TAccountInitializerConfig,
    TAccountLaunch,
    TAccountLaunchFeeState,
    TAccountLaunchAuthority,
    TAccountBaseMint,
    TAccountQuoteMint,
    TAccountLaunchBaseVault,
    TAccountLaunchQuoteVault,
    TAccountRehypeState,
    TAccountRehypeAuthority,
    TAccountRouterBaseAta,
    TAccountRouterQuoteAta,
    TAccountBuybackDestination,
    TAccountBuybackBaseAta,
    TAccountBuybackQuoteAta,
    TAccountCpmmProgram,
    TAccountCpmmConfig,
    TAccountPool,
    TAccountPoolAuthority,
    TAccountPoolVault0,
    TAccountPoolVault1,
    TAccountProtocolFeePosition,
    TAccountRouterLpPosition,
    TAccountBaseTokenProgram,
    TAccountQuoteTokenProgram,
    TAccountAssociatedTokenProgram,
    TAccountSystemProgram,
    TAccountOracle
  >
> {
  // Program address.
  const programAddress =
    config?.programAddress ?? DOPPLER_REHYPE_ROUTER_V1_PROGRAM_ADDRESS;

  // Original accounts.
  const originalAccounts = {
    settlementAuthority: {
      value: input.settlementAuthority ?? null,
      isWritable: true,
    },
    initializerProgram: {
      value: input.initializerProgram ?? null,
      isWritable: false,
    },
    initializerConfig: {
      value: input.initializerConfig ?? null,
      isWritable: false,
    },
    launch: { value: input.launch ?? null, isWritable: true },
    launchFeeState: { value: input.launchFeeState ?? null, isWritable: true },
    launchAuthority: {
      value: input.launchAuthority ?? null,
      isWritable: false,
    },
    baseMint: { value: input.baseMint ?? null, isWritable: false },
    quoteMint: { value: input.quoteMint ?? null, isWritable: false },
    launchBaseVault: { value: input.launchBaseVault ?? null, isWritable: true },
    launchQuoteVault: {
      value: input.launchQuoteVault ?? null,
      isWritable: true,
    },
    rehypeState: { value: input.rehypeState ?? null, isWritable: true },
    rehypeAuthority: {
      value: input.rehypeAuthority ?? null,
      isWritable: false,
    },
    routerBaseAta: { value: input.routerBaseAta ?? null, isWritable: true },
    routerQuoteAta: { value: input.routerQuoteAta ?? null, isWritable: true },
    buybackDestination: {
      value: input.buybackDestination ?? null,
      isWritable: false,
    },
    buybackBaseAta: { value: input.buybackBaseAta ?? null, isWritable: true },
    buybackQuoteAta: { value: input.buybackQuoteAta ?? null, isWritable: true },
    cpmmProgram: { value: input.cpmmProgram ?? null, isWritable: false },
    cpmmConfig: { value: input.cpmmConfig ?? null, isWritable: false },
    pool: { value: input.pool ?? null, isWritable: true },
    poolAuthority: { value: input.poolAuthority ?? null, isWritable: false },
    poolVault0: { value: input.poolVault0 ?? null, isWritable: true },
    poolVault1: { value: input.poolVault1 ?? null, isWritable: true },
    protocolFeePosition: {
      value: input.protocolFeePosition ?? null,
      isWritable: true,
    },
    routerLpPosition: {
      value: input.routerLpPosition ?? null,
      isWritable: true,
    },
    baseTokenProgram: {
      value: input.baseTokenProgram ?? null,
      isWritable: false,
    },
    quoteTokenProgram: {
      value: input.quoteTokenProgram ?? null,
      isWritable: false,
    },
    associatedTokenProgram: {
      value: input.associatedTokenProgram ?? null,
      isWritable: false,
    },
    systemProgram: { value: input.systemProgram ?? null, isWritable: false },
    oracle: { value: input.oracle ?? null, isWritable: true },
  };
  const accounts = originalAccounts as Record<
    keyof typeof originalAccounts,
    ResolvedInstructionAccount
  >;

  // Original args.
  const args = { ...input };

  // Resolve default values.
  if (!accounts.initializerProgram.value) {
    accounts.initializerProgram.value =
      '4h3Dqyo5qmteJoMxXt3tdtfXELDB6pdRTPU9mWruiKp1' as Address<'4h3Dqyo5qmteJoMxXt3tdtfXELDB6pdRTPU9mWruiKp1'>;
  }
  if (!accounts.rehypeState.value) {
    accounts.rehypeState.value = await getProgramDerivedAddress({
      programAddress,
      seeds: [
        getBytesEncoder().encode(
          new Uint8Array([
            114, 101, 104, 121, 112, 101, 95, 115, 116, 97, 116, 101,
          ]),
        ),
        getAddressEncoder().encode(
          getAddressFromResolvedInstructionAccount(
            'baseMint',
            accounts.baseMint.value,
          ),
        ),
      ],
    });
  }
  if (!accounts.rehypeAuthority.value) {
    accounts.rehypeAuthority.value = await getProgramDerivedAddress({
      programAddress,
      seeds: [
        getBytesEncoder().encode(
          new Uint8Array([
            114, 101, 104, 121, 112, 101, 95, 97, 117, 116, 104, 111, 114, 105,
            116, 121,
          ]),
        ),
        getAddressEncoder().encode(
          getAddressFromResolvedInstructionAccount(
            'rehypeState',
            accounts.rehypeState.value,
          ),
        ),
      ],
    });
  }
  if (!accounts.routerBaseAta.value) {
    accounts.routerBaseAta.value = await getProgramDerivedAddress({
      programAddress:
        'ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL' as Address<'ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL'>,
      seeds: [
        getAddressEncoder().encode(
          getAddressFromResolvedInstructionAccount(
            'rehypeAuthority',
            accounts.rehypeAuthority.value,
          ),
        ),
        getAddressEncoder().encode(
          getAddressFromResolvedInstructionAccount(
            'baseTokenProgram',
            accounts.baseTokenProgram.value,
          ),
        ),
        getAddressEncoder().encode(
          getAddressFromResolvedInstructionAccount(
            'baseMint',
            accounts.baseMint.value,
          ),
        ),
      ],
    });
  }
  if (!accounts.routerQuoteAta.value) {
    accounts.routerQuoteAta.value = await getProgramDerivedAddress({
      programAddress:
        'ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL' as Address<'ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL'>,
      seeds: [
        getAddressEncoder().encode(
          getAddressFromResolvedInstructionAccount(
            'rehypeAuthority',
            accounts.rehypeAuthority.value,
          ),
        ),
        getAddressEncoder().encode(
          getAddressFromResolvedInstructionAccount(
            'quoteTokenProgram',
            accounts.quoteTokenProgram.value,
          ),
        ),
        getAddressEncoder().encode(
          getAddressFromResolvedInstructionAccount(
            'quoteMint',
            accounts.quoteMint.value,
          ),
        ),
      ],
    });
  }
  if (!accounts.cpmmProgram.value) {
    accounts.cpmmProgram.value =
      '9PSxVPoPfnbZ8Q1uQhgS6ZxvBjFboZtebNsu34umxkgQ' as Address<'9PSxVPoPfnbZ8Q1uQhgS6ZxvBjFboZtebNsu34umxkgQ'>;
  }
  if (!accounts.associatedTokenProgram.value) {
    accounts.associatedTokenProgram.value =
      'ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL' as Address<'ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL'>;
  }
  if (!accounts.systemProgram.value) {
    accounts.systemProgram.value =
      '11111111111111111111111111111111' as Address<'11111111111111111111111111111111'>;
  }

  const getAccountMeta = getAccountMetaFactory(programAddress, 'programId');
  return Object.freeze({
    accounts: [
      getAccountMeta('settlementAuthority', accounts.settlementAuthority),
      getAccountMeta('initializerProgram', accounts.initializerProgram),
      getAccountMeta('initializerConfig', accounts.initializerConfig),
      getAccountMeta('launch', accounts.launch),
      getAccountMeta('launchFeeState', accounts.launchFeeState),
      getAccountMeta('launchAuthority', accounts.launchAuthority),
      getAccountMeta('baseMint', accounts.baseMint),
      getAccountMeta('quoteMint', accounts.quoteMint),
      getAccountMeta('launchBaseVault', accounts.launchBaseVault),
      getAccountMeta('launchQuoteVault', accounts.launchQuoteVault),
      getAccountMeta('rehypeState', accounts.rehypeState),
      getAccountMeta('rehypeAuthority', accounts.rehypeAuthority),
      getAccountMeta('routerBaseAta', accounts.routerBaseAta),
      getAccountMeta('routerQuoteAta', accounts.routerQuoteAta),
      getAccountMeta('buybackDestination', accounts.buybackDestination),
      getAccountMeta('buybackBaseAta', accounts.buybackBaseAta),
      getAccountMeta('buybackQuoteAta', accounts.buybackQuoteAta),
      getAccountMeta('cpmmProgram', accounts.cpmmProgram),
      getAccountMeta('cpmmConfig', accounts.cpmmConfig),
      getAccountMeta('pool', accounts.pool),
      getAccountMeta('poolAuthority', accounts.poolAuthority),
      getAccountMeta('poolVault0', accounts.poolVault0),
      getAccountMeta('poolVault1', accounts.poolVault1),
      getAccountMeta('protocolFeePosition', accounts.protocolFeePosition),
      getAccountMeta('routerLpPosition', accounts.routerLpPosition),
      getAccountMeta('baseTokenProgram', accounts.baseTokenProgram),
      getAccountMeta('quoteTokenProgram', accounts.quoteTokenProgram),
      getAccountMeta('associatedTokenProgram', accounts.associatedTokenProgram),
      getAccountMeta('systemProgram', accounts.systemProgram),
      getAccountMeta('oracle', accounts.oracle),
    ],
    data: getSettleMigratedFeesInstructionDataEncoder().encode(
      args as SettleMigratedFeesInstructionDataArgs,
    ),
    programAddress,
  } as SettleMigratedFeesInstruction<
    TProgramAddress,
    TAccountSettlementAuthority,
    TAccountInitializerProgram,
    TAccountInitializerConfig,
    TAccountLaunch,
    TAccountLaunchFeeState,
    TAccountLaunchAuthority,
    TAccountBaseMint,
    TAccountQuoteMint,
    TAccountLaunchBaseVault,
    TAccountLaunchQuoteVault,
    TAccountRehypeState,
    TAccountRehypeAuthority,
    TAccountRouterBaseAta,
    TAccountRouterQuoteAta,
    TAccountBuybackDestination,
    TAccountBuybackBaseAta,
    TAccountBuybackQuoteAta,
    TAccountCpmmProgram,
    TAccountCpmmConfig,
    TAccountPool,
    TAccountPoolAuthority,
    TAccountPoolVault0,
    TAccountPoolVault1,
    TAccountProtocolFeePosition,
    TAccountRouterLpPosition,
    TAccountBaseTokenProgram,
    TAccountQuoteTokenProgram,
    TAccountAssociatedTokenProgram,
    TAccountSystemProgram,
    TAccountOracle
  >);
}

export type SettleMigratedFeesInput<
  TAccountSettlementAuthority extends string = string,
  TAccountInitializerProgram extends string = string,
  TAccountInitializerConfig extends string = string,
  TAccountLaunch extends string = string,
  TAccountLaunchFeeState extends string = string,
  TAccountLaunchAuthority extends string = string,
  TAccountBaseMint extends string = string,
  TAccountQuoteMint extends string = string,
  TAccountLaunchBaseVault extends string = string,
  TAccountLaunchQuoteVault extends string = string,
  TAccountRehypeState extends string = string,
  TAccountRehypeAuthority extends string = string,
  TAccountRouterBaseAta extends string = string,
  TAccountRouterQuoteAta extends string = string,
  TAccountBuybackDestination extends string = string,
  TAccountBuybackBaseAta extends string = string,
  TAccountBuybackQuoteAta extends string = string,
  TAccountCpmmProgram extends string = string,
  TAccountCpmmConfig extends string = string,
  TAccountPool extends string = string,
  TAccountPoolAuthority extends string = string,
  TAccountPoolVault0 extends string = string,
  TAccountPoolVault1 extends string = string,
  TAccountProtocolFeePosition extends string = string,
  TAccountRouterLpPosition extends string = string,
  TAccountBaseTokenProgram extends string = string,
  TAccountQuoteTokenProgram extends string = string,
  TAccountAssociatedTokenProgram extends string = string,
  TAccountSystemProgram extends string = string,
  TAccountOracle extends string = string,
> = {
  settlementAuthority: TransactionSigner<TAccountSettlementAuthority>;
  initializerProgram?: Address<TAccountInitializerProgram>;
  initializerConfig: Address<TAccountInitializerConfig>;
  launch: Address<TAccountLaunch>;
  launchFeeState: Address<TAccountLaunchFeeState>;
  launchAuthority: Address<TAccountLaunchAuthority>;
  baseMint: Address<TAccountBaseMint>;
  quoteMint: Address<TAccountQuoteMint>;
  launchBaseVault: Address<TAccountLaunchBaseVault>;
  launchQuoteVault: Address<TAccountLaunchQuoteVault>;
  rehypeState: Address<TAccountRehypeState>;
  rehypeAuthority: Address<TAccountRehypeAuthority>;
  routerBaseAta: Address<TAccountRouterBaseAta>;
  routerQuoteAta: Address<TAccountRouterQuoteAta>;
  buybackDestination: Address<TAccountBuybackDestination>;
  buybackBaseAta: Address<TAccountBuybackBaseAta>;
  buybackQuoteAta: Address<TAccountBuybackQuoteAta>;
  cpmmProgram?: Address<TAccountCpmmProgram>;
  cpmmConfig: Address<TAccountCpmmConfig>;
  pool: Address<TAccountPool>;
  poolAuthority: Address<TAccountPoolAuthority>;
  poolVault0: Address<TAccountPoolVault0>;
  poolVault1: Address<TAccountPoolVault1>;
  protocolFeePosition: Address<TAccountProtocolFeePosition>;
  routerLpPosition: Address<TAccountRouterLpPosition>;
  baseTokenProgram: Address<TAccountBaseTokenProgram>;
  quoteTokenProgram: Address<TAccountQuoteTokenProgram>;
  associatedTokenProgram?: Address<TAccountAssociatedTokenProgram>;
  systemProgram?: Address<TAccountSystemProgram>;
  oracle?: Address<TAccountOracle>;
  minBaseToQuoteOut: SettleMigratedFeesInstructionDataArgs['minBaseToQuoteOut'];
  minQuoteToBaseOut: SettleMigratedFeesInstructionDataArgs['minQuoteToBaseOut'];
  lpRebalance: SettleMigratedFeesInstructionDataArgs['lpRebalance'];
  minLpSharesOut: SettleMigratedFeesInstructionDataArgs['minLpSharesOut'];
};

export function getSettleMigratedFeesInstruction<
  TAccountSettlementAuthority extends string,
  TAccountInitializerProgram extends string,
  TAccountInitializerConfig extends string,
  TAccountLaunch extends string,
  TAccountLaunchFeeState extends string,
  TAccountLaunchAuthority extends string,
  TAccountBaseMint extends string,
  TAccountQuoteMint extends string,
  TAccountLaunchBaseVault extends string,
  TAccountLaunchQuoteVault extends string,
  TAccountRehypeState extends string,
  TAccountRehypeAuthority extends string,
  TAccountRouterBaseAta extends string,
  TAccountRouterQuoteAta extends string,
  TAccountBuybackDestination extends string,
  TAccountBuybackBaseAta extends string,
  TAccountBuybackQuoteAta extends string,
  TAccountCpmmProgram extends string,
  TAccountCpmmConfig extends string,
  TAccountPool extends string,
  TAccountPoolAuthority extends string,
  TAccountPoolVault0 extends string,
  TAccountPoolVault1 extends string,
  TAccountProtocolFeePosition extends string,
  TAccountRouterLpPosition extends string,
  TAccountBaseTokenProgram extends string,
  TAccountQuoteTokenProgram extends string,
  TAccountAssociatedTokenProgram extends string,
  TAccountSystemProgram extends string,
  TAccountOracle extends string,
  TProgramAddress extends Address =
    typeof DOPPLER_REHYPE_ROUTER_V1_PROGRAM_ADDRESS,
>(
  input: SettleMigratedFeesInput<
    TAccountSettlementAuthority,
    TAccountInitializerProgram,
    TAccountInitializerConfig,
    TAccountLaunch,
    TAccountLaunchFeeState,
    TAccountLaunchAuthority,
    TAccountBaseMint,
    TAccountQuoteMint,
    TAccountLaunchBaseVault,
    TAccountLaunchQuoteVault,
    TAccountRehypeState,
    TAccountRehypeAuthority,
    TAccountRouterBaseAta,
    TAccountRouterQuoteAta,
    TAccountBuybackDestination,
    TAccountBuybackBaseAta,
    TAccountBuybackQuoteAta,
    TAccountCpmmProgram,
    TAccountCpmmConfig,
    TAccountPool,
    TAccountPoolAuthority,
    TAccountPoolVault0,
    TAccountPoolVault1,
    TAccountProtocolFeePosition,
    TAccountRouterLpPosition,
    TAccountBaseTokenProgram,
    TAccountQuoteTokenProgram,
    TAccountAssociatedTokenProgram,
    TAccountSystemProgram,
    TAccountOracle
  >,
  config?: { programAddress?: TProgramAddress },
): SettleMigratedFeesInstruction<
  TProgramAddress,
  TAccountSettlementAuthority,
  TAccountInitializerProgram,
  TAccountInitializerConfig,
  TAccountLaunch,
  TAccountLaunchFeeState,
  TAccountLaunchAuthority,
  TAccountBaseMint,
  TAccountQuoteMint,
  TAccountLaunchBaseVault,
  TAccountLaunchQuoteVault,
  TAccountRehypeState,
  TAccountRehypeAuthority,
  TAccountRouterBaseAta,
  TAccountRouterQuoteAta,
  TAccountBuybackDestination,
  TAccountBuybackBaseAta,
  TAccountBuybackQuoteAta,
  TAccountCpmmProgram,
  TAccountCpmmConfig,
  TAccountPool,
  TAccountPoolAuthority,
  TAccountPoolVault0,
  TAccountPoolVault1,
  TAccountProtocolFeePosition,
  TAccountRouterLpPosition,
  TAccountBaseTokenProgram,
  TAccountQuoteTokenProgram,
  TAccountAssociatedTokenProgram,
  TAccountSystemProgram,
  TAccountOracle
> {
  // Program address.
  const programAddress =
    config?.programAddress ?? DOPPLER_REHYPE_ROUTER_V1_PROGRAM_ADDRESS;

  // Original accounts.
  const originalAccounts = {
    settlementAuthority: {
      value: input.settlementAuthority ?? null,
      isWritable: true,
    },
    initializerProgram: {
      value: input.initializerProgram ?? null,
      isWritable: false,
    },
    initializerConfig: {
      value: input.initializerConfig ?? null,
      isWritable: false,
    },
    launch: { value: input.launch ?? null, isWritable: true },
    launchFeeState: { value: input.launchFeeState ?? null, isWritable: true },
    launchAuthority: {
      value: input.launchAuthority ?? null,
      isWritable: false,
    },
    baseMint: { value: input.baseMint ?? null, isWritable: false },
    quoteMint: { value: input.quoteMint ?? null, isWritable: false },
    launchBaseVault: { value: input.launchBaseVault ?? null, isWritable: true },
    launchQuoteVault: {
      value: input.launchQuoteVault ?? null,
      isWritable: true,
    },
    rehypeState: { value: input.rehypeState ?? null, isWritable: true },
    rehypeAuthority: {
      value: input.rehypeAuthority ?? null,
      isWritable: false,
    },
    routerBaseAta: { value: input.routerBaseAta ?? null, isWritable: true },
    routerQuoteAta: { value: input.routerQuoteAta ?? null, isWritable: true },
    buybackDestination: {
      value: input.buybackDestination ?? null,
      isWritable: false,
    },
    buybackBaseAta: { value: input.buybackBaseAta ?? null, isWritable: true },
    buybackQuoteAta: { value: input.buybackQuoteAta ?? null, isWritable: true },
    cpmmProgram: { value: input.cpmmProgram ?? null, isWritable: false },
    cpmmConfig: { value: input.cpmmConfig ?? null, isWritable: false },
    pool: { value: input.pool ?? null, isWritable: true },
    poolAuthority: { value: input.poolAuthority ?? null, isWritable: false },
    poolVault0: { value: input.poolVault0 ?? null, isWritable: true },
    poolVault1: { value: input.poolVault1 ?? null, isWritable: true },
    protocolFeePosition: {
      value: input.protocolFeePosition ?? null,
      isWritable: true,
    },
    routerLpPosition: {
      value: input.routerLpPosition ?? null,
      isWritable: true,
    },
    baseTokenProgram: {
      value: input.baseTokenProgram ?? null,
      isWritable: false,
    },
    quoteTokenProgram: {
      value: input.quoteTokenProgram ?? null,
      isWritable: false,
    },
    associatedTokenProgram: {
      value: input.associatedTokenProgram ?? null,
      isWritable: false,
    },
    systemProgram: { value: input.systemProgram ?? null, isWritable: false },
    oracle: { value: input.oracle ?? null, isWritable: true },
  };
  const accounts = originalAccounts as Record<
    keyof typeof originalAccounts,
    ResolvedInstructionAccount
  >;

  // Original args.
  const args = { ...input };

  // Resolve default values.
  if (!accounts.initializerProgram.value) {
    accounts.initializerProgram.value =
      '4h3Dqyo5qmteJoMxXt3tdtfXELDB6pdRTPU9mWruiKp1' as Address<'4h3Dqyo5qmteJoMxXt3tdtfXELDB6pdRTPU9mWruiKp1'>;
  }
  if (!accounts.cpmmProgram.value) {
    accounts.cpmmProgram.value =
      '9PSxVPoPfnbZ8Q1uQhgS6ZxvBjFboZtebNsu34umxkgQ' as Address<'9PSxVPoPfnbZ8Q1uQhgS6ZxvBjFboZtebNsu34umxkgQ'>;
  }
  if (!accounts.associatedTokenProgram.value) {
    accounts.associatedTokenProgram.value =
      'ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL' as Address<'ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL'>;
  }
  if (!accounts.systemProgram.value) {
    accounts.systemProgram.value =
      '11111111111111111111111111111111' as Address<'11111111111111111111111111111111'>;
  }

  const getAccountMeta = getAccountMetaFactory(programAddress, 'programId');
  return Object.freeze({
    accounts: [
      getAccountMeta('settlementAuthority', accounts.settlementAuthority),
      getAccountMeta('initializerProgram', accounts.initializerProgram),
      getAccountMeta('initializerConfig', accounts.initializerConfig),
      getAccountMeta('launch', accounts.launch),
      getAccountMeta('launchFeeState', accounts.launchFeeState),
      getAccountMeta('launchAuthority', accounts.launchAuthority),
      getAccountMeta('baseMint', accounts.baseMint),
      getAccountMeta('quoteMint', accounts.quoteMint),
      getAccountMeta('launchBaseVault', accounts.launchBaseVault),
      getAccountMeta('launchQuoteVault', accounts.launchQuoteVault),
      getAccountMeta('rehypeState', accounts.rehypeState),
      getAccountMeta('rehypeAuthority', accounts.rehypeAuthority),
      getAccountMeta('routerBaseAta', accounts.routerBaseAta),
      getAccountMeta('routerQuoteAta', accounts.routerQuoteAta),
      getAccountMeta('buybackDestination', accounts.buybackDestination),
      getAccountMeta('buybackBaseAta', accounts.buybackBaseAta),
      getAccountMeta('buybackQuoteAta', accounts.buybackQuoteAta),
      getAccountMeta('cpmmProgram', accounts.cpmmProgram),
      getAccountMeta('cpmmConfig', accounts.cpmmConfig),
      getAccountMeta('pool', accounts.pool),
      getAccountMeta('poolAuthority', accounts.poolAuthority),
      getAccountMeta('poolVault0', accounts.poolVault0),
      getAccountMeta('poolVault1', accounts.poolVault1),
      getAccountMeta('protocolFeePosition', accounts.protocolFeePosition),
      getAccountMeta('routerLpPosition', accounts.routerLpPosition),
      getAccountMeta('baseTokenProgram', accounts.baseTokenProgram),
      getAccountMeta('quoteTokenProgram', accounts.quoteTokenProgram),
      getAccountMeta('associatedTokenProgram', accounts.associatedTokenProgram),
      getAccountMeta('systemProgram', accounts.systemProgram),
      getAccountMeta('oracle', accounts.oracle),
    ],
    data: getSettleMigratedFeesInstructionDataEncoder().encode(
      args as SettleMigratedFeesInstructionDataArgs,
    ),
    programAddress,
  } as SettleMigratedFeesInstruction<
    TProgramAddress,
    TAccountSettlementAuthority,
    TAccountInitializerProgram,
    TAccountInitializerConfig,
    TAccountLaunch,
    TAccountLaunchFeeState,
    TAccountLaunchAuthority,
    TAccountBaseMint,
    TAccountQuoteMint,
    TAccountLaunchBaseVault,
    TAccountLaunchQuoteVault,
    TAccountRehypeState,
    TAccountRehypeAuthority,
    TAccountRouterBaseAta,
    TAccountRouterQuoteAta,
    TAccountBuybackDestination,
    TAccountBuybackBaseAta,
    TAccountBuybackQuoteAta,
    TAccountCpmmProgram,
    TAccountCpmmConfig,
    TAccountPool,
    TAccountPoolAuthority,
    TAccountPoolVault0,
    TAccountPoolVault1,
    TAccountProtocolFeePosition,
    TAccountRouterLpPosition,
    TAccountBaseTokenProgram,
    TAccountQuoteTokenProgram,
    TAccountAssociatedTokenProgram,
    TAccountSystemProgram,
    TAccountOracle
  >);
}

export type ParsedSettleMigratedFeesInstruction<
  TProgram extends string = typeof DOPPLER_REHYPE_ROUTER_V1_PROGRAM_ADDRESS,
  TAccountMetas extends readonly AccountMeta[] = readonly AccountMeta[],
> = {
  programAddress: Address<TProgram>;
  accounts: {
    settlementAuthority: TAccountMetas[0];
    initializerProgram: TAccountMetas[1];
    initializerConfig: TAccountMetas[2];
    launch: TAccountMetas[3];
    launchFeeState: TAccountMetas[4];
    launchAuthority: TAccountMetas[5];
    baseMint: TAccountMetas[6];
    quoteMint: TAccountMetas[7];
    launchBaseVault: TAccountMetas[8];
    launchQuoteVault: TAccountMetas[9];
    rehypeState: TAccountMetas[10];
    rehypeAuthority: TAccountMetas[11];
    routerBaseAta: TAccountMetas[12];
    routerQuoteAta: TAccountMetas[13];
    buybackDestination: TAccountMetas[14];
    buybackBaseAta: TAccountMetas[15];
    buybackQuoteAta: TAccountMetas[16];
    cpmmProgram: TAccountMetas[17];
    cpmmConfig: TAccountMetas[18];
    pool: TAccountMetas[19];
    poolAuthority: TAccountMetas[20];
    poolVault0: TAccountMetas[21];
    poolVault1: TAccountMetas[22];
    protocolFeePosition: TAccountMetas[23];
    routerLpPosition: TAccountMetas[24];
    baseTokenProgram: TAccountMetas[25];
    quoteTokenProgram: TAccountMetas[26];
    associatedTokenProgram: TAccountMetas[27];
    systemProgram: TAccountMetas[28];
    oracle?: TAccountMetas[29] | undefined;
  };
  data: SettleMigratedFeesInstructionData;
};

export function parseSettleMigratedFeesInstruction<
  TProgram extends string,
  TAccountMetas extends readonly AccountMeta[],
>(
  instruction: Instruction<TProgram> &
    InstructionWithAccounts<TAccountMetas> &
    InstructionWithData<ReadonlyUint8Array>,
): ParsedSettleMigratedFeesInstruction<TProgram, TAccountMetas> {
  if (instruction.accounts.length < 30) {
    throw new SolanaError(
      SOLANA_ERROR__PROGRAM_CLIENTS__INSUFFICIENT_ACCOUNT_METAS,
      {
        actualAccountMetas: instruction.accounts.length,
        expectedAccountMetas: 30,
      },
    );
  }
  let accountIndex = 0;
  const getNextAccount = () => {
    const accountMeta = (instruction.accounts as TAccountMetas)[accountIndex]!;
    accountIndex += 1;
    return accountMeta;
  };
  const getNextOptionalAccount = () => {
    const accountMeta = getNextAccount();
    return accountMeta.address === DOPPLER_REHYPE_ROUTER_V1_PROGRAM_ADDRESS
      ? undefined
      : accountMeta;
  };
  return {
    programAddress: instruction.programAddress,
    accounts: {
      settlementAuthority: getNextAccount(),
      initializerProgram: getNextAccount(),
      initializerConfig: getNextAccount(),
      launch: getNextAccount(),
      launchFeeState: getNextAccount(),
      launchAuthority: getNextAccount(),
      baseMint: getNextAccount(),
      quoteMint: getNextAccount(),
      launchBaseVault: getNextAccount(),
      launchQuoteVault: getNextAccount(),
      rehypeState: getNextAccount(),
      rehypeAuthority: getNextAccount(),
      routerBaseAta: getNextAccount(),
      routerQuoteAta: getNextAccount(),
      buybackDestination: getNextAccount(),
      buybackBaseAta: getNextAccount(),
      buybackQuoteAta: getNextAccount(),
      cpmmProgram: getNextAccount(),
      cpmmConfig: getNextAccount(),
      pool: getNextAccount(),
      poolAuthority: getNextAccount(),
      poolVault0: getNextAccount(),
      poolVault1: getNextAccount(),
      protocolFeePosition: getNextAccount(),
      routerLpPosition: getNextAccount(),
      baseTokenProgram: getNextAccount(),
      quoteTokenProgram: getNextAccount(),
      associatedTokenProgram: getNextAccount(),
      systemProgram: getNextAccount(),
      oracle: getNextOptionalAccount(),
    },
    data: getSettleMigratedFeesInstructionDataDecoder().decode(
      instruction.data,
    ),
  };
}
